<template lang="pug">
.loader(:class="{error}")
	.loader__spinner(v-if="loading && !error")
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		div.loader__bubble
		span.loader__text Loading...
	h4.loader__copy(v-else)
		span {{errorText}}
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Loader",
	data() {
		return {
			errorText: this.$root.loadError
		}
	},
	computed: {
		...mapGetters(["loading", "error"]),
	}
}
</script>

<style lang="scss" scoped>
// @import "../../../../scss/abstracts/_functions.scss";
// @import "../../../../scss/abstracts/_mixins.scss";
// @import "../../../../scss/abstracts/_variables.scss";

$delay: 0.065s;
$duration: 1.5s;

@mixin rotate($n) {
	transform: rotate($n * 30deg);
}

.loader {
	max-width: 700px;
	height: 200px;
	margin: 2rem auto;
	&__spinner {
		height: 160px;
		width: 160x;
		position: relative;
		margin: 0 auto;
	}
	&__bubble {
		position: absolute;
		width: 100%;
		height: 100%;
		&::after {
			content: '';
			position: absolute;
			height: 16px;
			width: 16px;
			min-width: 16px;
			border-radius: 50%;
			display: block;
			top: 0;
			left: calc(50% - 8px);
			background: transparent;
			transition: 0.25s ease;
		}

		@for $i from 1 through 12 {
			&:nth-child(#{$i}) {
				@include rotate($i);
				&::after {
					animation: colorChange infinite $duration ease;
					animation-delay: $delay * $i;
				}
			}
		}
	}
	&__text {
		font-weight: 700;
		position: absolute;
		top: calc(50% - 8px);
		left: 50%;
		transform: translateX(-50%);
	}
	&__copy {
		width: fit-content;
		margin: 0 auto;
		.error & {
			&::before {
				@include icon;
				content: "\e902";
				font-size: 5rem;
				width: 100%;
				display: block;
				text-align: center;
				margin-bottom: 2rem;
			}
		}
	}
	&.fadeIn-leave-active,
	&.fadeIn-leave-to {
		display: none;
		opacity: 0;
		width: 0;
	}
}



@keyframes colorChange {
	0% {
		background: transparent;
	}
	33% {
		background: $blue;
	}
	66% {
		background: $red;
	}
	100% {
		background: transparent;
	}
}
</style>